"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Suggestions = void 0;
const react_1 = __importDefault(require("react"));
const suggestion_styles_1 = require("./suggestion.styles");
const Suggestions = ({ suggestions, onSelectSuggestion, }) => {
    const handleClick = (suggestion) => () => {
        onSelectSuggestion(suggestion);
    };
    return (react_1.default.createElement(suggestion_styles_1.SuggestionContainer, null, suggestions.map((suggestion) => (react_1.default.createElement(suggestion_styles_1.SuggestionButton, { variant: "text", onClick: handleClick(suggestion), key: suggestion.key || null }, suggestion.label)))));
};
exports.Suggestions = Suggestions;
